import { html } from "htm/preact/index.js";
import { useAppContext } from "src/services/context";

function LiveAnnouncer() {
    const state = useAppContext();

    return html`
        <div
            class="sr-only"
            role="status"
            aria-live="polite"
            aria-atomic="true"
        >
            ${state.liveAnnouncement.value}
        </div>
    `;
}

export default LiveAnnouncer;